"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowRight, Calendar, PlayCircle } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
function MediaGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch,
    hasNext,
    loadMore,
    isRefetching
  } = usePosts();
  if (loading) {
    return <div data-section-id="38201" className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-8">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse bg-muted" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-destructive mb-4">Gagal memuat konten media.</p>
        <Button onClick={refetch} variant="outline">
          Coba Lagi
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground">Tidak ada media ditemukan.</p>
      </div>;
  }
  return <div className="space-y-12">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-8">
        {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group block h-full" data-index={i}>
            <Card className="h-full border-[#F2F2F2] bg-card transition-all duration-[400ms] ease-in-out hover:shadow-[0_4px_10px_rgba(0,0,0,0.05)] border border-solid rounded-none overflow-hidden flex flex-col pb-4 md:pb-6">
              {}
              <div className="relative aspect-square md:aspect-video w-full overflow-hidden bg-[#F2F2F2]">
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-[400ms] ease-in-out group-hover:scale-[1.02]" /> : <div className="flex h-full w-full items-center justify-center bg-[#F2F2F2] text-muted-foreground">
                    <PlayCircle className="h-12 w-12 opacity-20" strokeWidth={1} />
                  </div>}
                
                {}
                <div className="absolute inset-0 flex items-center justify-center bg-primary/0 transition-colors duration-300 group-hover:bg-primary/5">
                  <div className="rounded-full bg-background/95 p-3 opacity-0 shadow-sm transition-all duration-[400ms] group-hover:opacity-100 group-hover:scale-105">
                    <ArrowRight className="h-5 w-5 text-primary" strokeWidth={1.5} />
                  </div>
                </div>
              </div>

              <CardHeader className="p-4 pb-2 md:p-6 md:pb-2">
                <div className="mb-3 inline-flex items-center gap-2 text-[16px] font-medium text-black bg-[#F2F2F2] px-2 py-0.5 uppercase tracking-wider font-sans">
                  <SafeHydrate><Calendar className="h-3.5 w-3.5" /></SafeHydrate>
                  <span>
                    {post.date ? new Date(post.date).toLocaleDateString("id-ID", {
                  month: "long",
                  day: "numeric",
                  year: "numeric"
                }) : "Terbaru"}
                  </span>
                </div>
                <CardTitle className="font-sans text-[20px] md:text-[22px] lg:text-[24px] font-bold leading-tight text-foreground line-clamp-2">
                  {post.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="p-4 pt-2 md:p-6 md:pt-2 flex-grow">
                <div className="font-sans text-[14px] md:text-[15px] lg:text-[16px] font-light leading-[1.6] text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
              __html: post.excerpt || ""
            }} />
              </CardContent>

              <CardFooter className="p-4 pt-0 md:p-6 md:pt-0 mt-auto">
                <span className="inline-flex items-center gap-2 text-[16px] font-semibold text-primary group-hover:underline underline-offset-4 font-sans">
                  Selengkapnya <ArrowRight className="h-4 w-4" />
                </span>
              </CardFooter>
            </Card>
          </Link>)}
      </div>

      {hasNext && <div className="flex justify-center pt-8">
          <Button onClick={async () => await loadMore()} disabled={isRefetching} size="lg" className="h-10 md:h-12 min-w-[160px] md:min-w-[220px] text-sm md:text-base font-semibold tracking-wide bg-primary hover:bg-primary/90 text-primary-foreground rounded-none">
            {isRefetching ? "Memuat..." : "Lihat Lebih Banyak"}
          </Button>
        </div>}
    </div>;
}
export default function MediaGrid() {
  const wp_query_params = {
    per_page: 9,
    order: "desc",
    orderby: "date",
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="grid-konten-live" className="bg-background text-foreground py-12 md:py-20 lg:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight font-sans">
            Liputan Terkini
          </h2>
          <p className="text-[16px] md:text-[17px] lg:text-[18px] text-muted-foreground font-light leading-relaxed font-sans">
            Akses berita terbaru, klarifikasi eksklusif, dan dokumentasi kegiatan dari seluruh penjuru wilayah untuk tetap terinformasi.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 9,
        order: "desc",
        orderby: "date",
        status: ["publish"]
      }} className="w-full">
          <MediaGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}